import { Component, Input } from '@angular/core';
import { ChatAIMessage } from './chat-AI.component';

@Component({
  selector: 'chat-AI-message',
  template: `
        <div class="avatar-container">
            <span class="avatar {{message.sender}}">
                <img *ngIf="message.sender !== 'user'" src="https://media.staticontent.com/media/pictures/9fbd3e88-ef79-4d99-a480-4d7ba0bfa1f4/40x40?op=TRUNCATE" alt="avatar">
                <img *ngIf="message.sender === 'user' && userAvatar !== null && userAvatar !== ''" [src]="userAvatar" alt="avatar">
                <i *ngIf="message.sender === 'user' && (userAvatar === null || userAvatar === '')" class="eva-3-icon-user icon-user"></i>
            </span>
        </div>

        <div class="message-container">
            <div class="message" [innerHTML]="message.message"></div>

            <ng-content></ng-content>
        </div>
    `
})

export class ChatAIMessageComponent {
  @Input() message: ChatAIMessage;
  @Input() userAvatar?: string;

  constructor() { }
}
